(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanySubscriptionStatusCustom', CompanySubscriptionStatusCustom);

    CompanySubscriptionStatusCustom.$inject = ['$resource', 'ENV'];

    function CompanySubscriptionStatusCustom($resource, ENV) {


        var getCurrentCompanySubscriptionStatus = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/get-current-company-subscription-status';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var findActiveCompanySubscription = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/find-active-company-subscription-status';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var insertCompanySubscriptionStatus = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/insert-company-subscription-status';
            return $resource(resourceUrl, {}, {}
            );
        };

        var confirmSubscription = function (token, refid) {

            var resourceUrl = ENV.API_BASE_URL + 'api/subscription-confirmation?token=' + token + "&refid=" + refid;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var getCompanyTotalStatus = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/company-subscription-status';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var canCurrentCompanyReserve = function (companyId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/can-current-company-reserve?companyId=' + companyId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var findLastSubscriptionByCurrentCompany = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/find-last-subscription-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var evaluateSupplierCoupon = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/evaluate-supplier-coupon';
            return $resource(resourceUrl, {}, {}
            );
        };

        var computeSubscriptionFinalPrice = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/compute-subscription-final-price';
            return $resource(resourceUrl, {}, {}
            );
        };

        var findTestCompanySubscriptionStatus = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/find-first-company-subscription-status';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var companySubscriptionStatusManual = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/company-subscription-statuses-manual';
            return $resource(resourceUrl, {}, {
                    'update': {method: 'PUT'}
                }
            );
        };


        var isCurrentCompanyHasActiveSubscription = function () {

            var resourceUrl = 'api/is-current-company-has-active-subscription';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var searchCompanySubscriptionStatusByQueryPage = function () {
            var resourceUrl = 'api/search-company-subscription-status-page';
            return $resource(resourceUrl, {}, {
                    'save': {method: 'POST', isArray: true}
                }
            );
        };


        return {
            getCompanyTotalStatus: getCompanyTotalStatus,
            getCurrentCompanySubscriptionStatus: getCurrentCompanySubscriptionStatus,
            insertCompanySubscriptionStatus: insertCompanySubscriptionStatus,
            confirmSubscription: confirmSubscription,
            findActiveCompanySubscription: findActiveCompanySubscription,
            canCurrentCompanyReserve: canCurrentCompanyReserve,
            findLastSubscriptionByCurrentCompany: findLastSubscriptionByCurrentCompany,
            evaluateSupplierCoupon: evaluateSupplierCoupon,
            computeSubscriptionFinalPrice: computeSubscriptionFinalPrice,
            findTestCompanySubscriptionStatus: findTestCompanySubscriptionStatus,
            companySubscriptionStatusManual: companySubscriptionStatusManual,
            isCurrentCompanyHasActiveSubscription: isCurrentCompanyHasActiveSubscription,
            searchCompanySubscriptionStatusByQueryPage: searchCompanySubscriptionStatusByQueryPage

        };
    }
})();
